import type { ComponentProps } from "react";
import { ImageButton } from "../buttons";
import { Link, useMatch } from "react-router-dom";
import { scrollToTop } from "./utils";
import { HomeImageButton } from "../buttons/image-button/HomeImageButton";

const HomeImageButtonLink = ({
  href,
  ...props
}: ComponentProps<typeof ImageButton> & {
  href: string;
}) => {
  const match = useMatch(href);
  const isMatch = Boolean(match);
  return (
    <Link to={href}>
      <HomeImageButton
        active={isMatch}
        onClick={isMatch ? scrollToTop : undefined}
        {...props}
      />
    </Link>
  );
};

HomeImageButtonLink.displayName = "ImageButtonLink";

export { HomeImageButtonLink };
